var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404IllustrationLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "970px",
    height: "331px",
    viewBox: "0 0 970 331",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.3865017%",
    y1: "5.66565973%",
    x2: "53.9409722%",
    y2: "57.6377674%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.4957682%",
    y1: "0%",
    x2: "43.5481771%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "42.7075447%",
    x2: "24.2768159%",
    y2: "56.9662867%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M695.486486,40 L695.486421,39.8411346 C691.785523,39.1053273 689,35.900675 689,32.0588235 C689,27.6730329 692.630124,24.1176471 697.108108,24.1176471 C699.540151,24.1176471 701.7221,25.1663777 703.208235,26.8272937 C704.75978,24.2548518 707.620101,22.5294118 710.891892,22.5294118 L710.721681,22.5320382 C712.553823,17.0126222 718.108156,13 724.675676,13 C731.932734,13 737.952682,17.8994425 739.080523,24.317454 C739.662685,24.186421 740.269088,24.1176471 740.891892,24.1176471 C745.369876,24.1176471 749,27.6730329 749,32.0588235 C749,32.0815133 748.999903,32.1041808 748.999709,32.1268257 C749.319088,32.0438225 749.654426,32 750,32 C752.209139,32 754,33.790861 754,36 C754,38.209139 752.209139,40 750,40 C749.825947,40 749.65449,39.9888832 749.486301,39.9673208 L749.486486,40 L695.486486,40 Z M734.283379,36.660952 L734.104503,36.8048634 C734.096234,36.8113439 734.087956,36.817816 734.079671,36.8242798 L734.405045,36.8238341 C734.363805,36.7700654 734.323245,36.7157673 734.283379,36.660952 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.5%",
    y: "-20.4%",
    width: "116.9%",
    height: "140.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.486486,27 L222.486421,26.8411346 C218.785523,26.1053273 216,22.900675 216,19.0588235 C216,14.6730329 219.630124,11.1176471 224.108108,11.1176471 C226.540151,11.1176471 228.7221,12.1663777 230.208235,13.8272937 C231.75978,11.2548518 234.620101,9.52941176 237.891892,9.52941176 L237.721681,9.53203819 C239.553823,4.01262216 245.108156,0 251.675676,0 C258.932734,0 264.952682,4.89944245 266.080523,11.317454 C266.662685,11.186421 267.269088,11.1176471 267.891892,11.1176471 C272.369876,11.1176471 276,14.6730329 276,19.0588235 C276,19.0815133 275.999903,19.1041808 275.999709,19.1268257 C276.319088,19.0438225 276.654426,19 277,19 C279.209139,19 281,20.790861 281,23 C281,25.209139 279.209139,27 277,27 C276.825947,27 276.65449,26.9888832 276.486301,26.9673208 L276.486486,27 L222.486486,27 Z M261.283379,23.660952 L261.104503,23.8048634 C261.096234,23.8113439 261.087956,23.817816 261.079671,23.8242798 L261.405045,23.8238341 C261.363805,23.7700654 261.323245,23.7157673 261.283379,23.660952 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.5%",
    y: "-20.4%",
    width: "116.9%",
    height: "140.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "42.8340925%",
    x2: "24.2768159%",
    y2: "56.845399%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291,14 C288.790861,14 287,12.209139 287,10 C287,7.790861 288.790861,6 291,6 C292.393644,6 293.620823,6.71272106 294.33693,7.79355532 C295.007639,6.1540312 296.61905,5 298.5,5 L298.30916,5.00447284 C299.229642,2.11068575 302.100726,0 305.5,0 C309.331015,0 312.49115,2.68089035 312.944259,6.14226962 C313.279795,6.04911259 313.634162,6 314,6 C316.209139,6 318,7.790861 318,10 C318,10.0924298 317.996865,10.1841273 317.990695,10.2749921 C318.285562,10.0998664 318.631119,10 319,10 C320.104569,10 321,10.8954305 321,12 C321,13.1045695 320.104569,14 319,14 L319,14 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-39.3%",
    width: "132.4%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518,34 C515.790861,34 514,32.209139 514,30 C514,27.790861 515.790861,26 518,26 C519.393644,26 520.620823,26.7127211 521.33693,27.7935553 C522.007639,26.1540312 523.61905,25 525.5,25 L525.30916,25.0044728 C526.229642,22.1106857 529.100726,20 532.5,20 C536.331015,20 539.49115,22.6808904 539.944259,26.1422696 C540.279795,26.0491126 540.634162,26 541,26 C543.209139,26 545,27.790861 545,30 C545,30.0924298 544.996865,30.1841273 544.990695,30.2749921 C545.285562,30.0998664 545.631119,30 546,30 C547.104569,30 548,30.8954305 548,32 C548,33.1045695 547.104569,34 546,34 L546,34 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-39.3%",
    width: "132.4%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "234.798672%",
    x2: "50%",
    y2: "60.9872109%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "51.5155788%",
    fx: "48.9155431%",
    fy: "51.5155788%",
    r: "47.6580123%",
    gradientTransform: "translate(0.489155,0.515156),scale(0.112245,1.000000),rotate(90.000000),scale(1.000000,9.340697),translate(-0.489155,-0.515156)",
    id: "radialGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50%",
    fx: "48.9155431%",
    fy: "50%",
    r: "49.173591%",
    gradientTransform: "translate(0.489155,0.500000),scale(0.148148,1.000000),rotate(90.000000),scale(1.000000,6.549158),translate(-0.489155,-0.500000)",
    id: "radialGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.3463739%",
    y1: "-17.6846596%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-17",
    cx: 350,
    cy: 170.482364,
    r: 38
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.3%",
    y: "-3.3%",
    width: "106.6%",
    height: "106.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50%",
    fx: "48.9155431%",
    fy: "50%",
    r: "49.173591%",
    gradientTransform: "translate(0.489155,0.500000),scale(0.080382,1.000000),rotate(90.000000),scale(1.000000,13.366712),translate(-0.489155,-0.500000)",
    id: "radialGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.8958899%",
    y1: "35.5406621%",
    x2: "27.6520041%",
    y2: "71.7686607%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M469.692059,152.635724 C470.333726,152.635724 470.858726,153.160724 470.858726,153.802391 L470.858726,153.802391 L470.858726,155.351724 C471.926226,155.627057 472.933059,156.047057 473.859392,156.594224 L473.859392,156.594224 L474.953726,155.498724 C475.407559,155.044891 476.150726,155.044891 476.604559,155.498724 L476.604559,155.498724 L479.079059,157.973224 C479.532892,158.427057 479.532892,159.170224 479.079059,159.624057 L479.079059,159.624057 L477.983559,160.718391 C478.530726,161.644724 478.950726,162.651557 479.226059,163.719057 L479.226059,163.719057 L480.775392,163.719057 C481.417059,163.719057 481.942059,164.244057 481.942059,164.885724 L481.942059,164.885724 L481.942059,168.385724 C481.942059,169.027391 481.417059,169.552391 480.775392,169.552391 L480.775392,169.552391 L479.226059,169.552391 C478.950726,170.619891 478.530726,171.626724 477.983559,172.553057 L477.983559,172.553057 L479.079059,173.647391 C479.532892,174.101224 479.532892,174.844391 479.079059,175.298224 L479.079059,175.298224 L476.604559,177.772724 C476.150726,178.226557 475.407559,178.226557 474.953726,177.772724 L474.953726,177.772724 L473.859392,176.677224 C472.933059,177.224391 471.926226,177.644391 470.858726,177.919724 L470.858726,177.919724 L470.858726,179.469057 C470.858726,180.110724 470.333726,180.635724 469.692059,180.635724 L469.692059,180.635724 L466.192059,180.635724 C465.550392,180.635724 465.025392,180.110724 465.025392,179.469057 L465.025392,179.469057 L465.025392,177.919724 C463.957892,177.644391 462.951059,177.224391 462.024726,176.677224 L462.024726,176.677224 L460.930392,177.772724 C460.476559,178.226557 459.733392,178.226557 459.279559,177.772724 L459.279559,177.772724 L456.805059,175.298224 C456.351226,174.844391 456.351226,174.101224 456.805059,173.647391 L456.805059,173.647391 L457.900559,172.553057 C457.353392,171.626724 456.933392,170.619891 456.658059,169.552391 L456.658059,169.552391 L455.108726,169.552391 C454.467059,169.552391 453.942059,169.027391 453.942059,168.385724 L453.942059,168.385724 L453.942059,164.885724 C453.942059,164.244057 454.467059,163.719057 455.108726,163.719057 L455.108726,163.719057 L456.658059,163.719057 C456.933392,162.651557 457.353392,161.644724 457.900559,160.718391 L457.900559,160.718391 L456.805059,159.624057 C456.351226,159.170224 456.351226,158.427057 456.805059,157.973224 L456.805059,157.973224 L459.279559,155.498724 C459.733392,155.044891 460.476559,155.044891 460.930392,155.498724 L460.930392,155.498724 L462.024726,156.594224 C462.951059,156.047057 463.957892,155.627057 465.025392,155.351724 L465.025392,155.351724 L465.025392,153.802391 C465.025392,153.160724 465.550392,152.635724 466.192059,152.635724 L466.192059,152.635724 Z M467.442059,161.635724 C464.956778,161.635724 462.942059,163.650443 462.942059,166.135724 C462.942059,168.621005 464.956778,170.635724 467.442059,170.635724 C469.92734,170.635724 471.942059,168.621005 471.942059,166.135724 C471.942059,163.650443 469.92734,161.635724 467.442059,161.635724 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.1%",
    y: "-7.1%",
    width: "114.3%",
    height: "114.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-23"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.437854,187.685624 C441.537854,187.685624 442.437854,188.585624 442.437854,189.685624 L442.437854,189.685624 L442.437854,192.341624 C444.267854,192.813624 445.993854,193.533624 447.581854,194.471624 L447.581854,194.471624 L449.457854,192.593624 C450.235854,191.815624 451.509854,191.815624 452.287854,192.593624 L452.287854,192.593624 L456.529854,196.835624 C457.307854,197.613624 457.307854,198.887624 456.529854,199.665624 L456.529854,199.665624 L454.651854,201.541624 C455.589854,203.129624 456.309854,204.855624 456.781854,206.685624 L456.781854,206.685624 L459.437854,206.685624 C460.537854,206.685624 461.437854,207.585624 461.437854,208.685624 L461.437854,208.685624 L461.437854,214.685624 C461.437854,215.785624 460.537854,216.685624 459.437854,216.685624 L459.437854,216.685624 L456.781854,216.685624 C456.309854,218.515624 455.589854,220.241624 454.651854,221.829624 L454.651854,221.829624 L456.529854,223.705624 C457.307854,224.483624 457.307854,225.757624 456.529854,226.535624 L456.529854,226.535624 L452.287854,230.777624 C451.509854,231.555624 450.235854,231.555624 449.457854,230.777624 L449.457854,230.777624 L447.581854,228.899624 C445.993854,229.837624 444.267854,230.557624 442.437854,231.029624 L442.437854,231.029624 L442.437854,233.685624 C442.437854,234.785624 441.537854,235.685624 440.437854,235.685624 L440.437854,235.685624 L434.437854,235.685624 C433.337854,235.685624 432.437854,234.785624 432.437854,233.685624 L432.437854,233.685624 L432.437854,231.029624 C430.607854,230.557624 428.881854,229.837624 427.293854,228.899624 L427.293854,228.899624 L425.417854,230.777624 C424.639854,231.555624 423.365854,231.555624 422.587854,230.777624 L422.587854,230.777624 L418.345854,226.535624 C417.567854,225.757624 417.567854,224.483624 418.345854,223.705624 L418.345854,223.705624 L420.223854,221.829624 C419.285854,220.241624 418.565854,218.515624 418.093854,216.685624 L418.093854,216.685624 L415.437854,216.685624 C414.337854,216.685624 413.437854,215.785624 413.437854,214.685624 L413.437854,214.685624 L413.437854,208.685624 C413.437854,207.585624 414.337854,206.685624 415.437854,206.685624 L415.437854,206.685624 L418.093854,206.685624 C418.565854,204.855624 419.285854,203.129624 420.223854,201.541624 L420.223854,201.541624 L418.345854,199.665624 C417.567854,198.887624 417.567854,197.613624 418.345854,196.835624 L418.345854,196.835624 L422.587854,192.593624 C423.365854,191.815624 424.639854,191.815624 425.417854,192.593624 L425.417854,192.593624 L427.293854,194.471624 C428.881854,193.533624 430.607854,192.813624 432.437854,192.341624 L432.437854,192.341624 L432.437854,189.685624 C432.437854,188.585624 433.337854,187.685624 434.437854,187.685624 L434.437854,187.685624 Z M437.437854,203.685624 C433.019576,203.685624 429.437854,207.267346 429.437854,211.685624 C429.437854,216.103902 433.019576,219.685624 437.437854,219.685624 C441.856132,219.685624 445.437854,216.103902 445.437854,211.685624 C445.437854,207.267346 441.856132,203.685624 437.437854,203.685624 Z",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.5%",
    y: "-7.3%",
    width: "127.1%",
    height: "129.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.028721,163.612202 L485.171192,176.04947 C494.0696,178.132021 500.587372,185.748137 501.270232,194.861445 C501.921272,203.550098 495.873643,211.314969 487.290081,212.8113 L429.889768,222.817619 C413.541097,225.667604 397.977513,214.724758 395.127528,198.376087 C394.77078,196.329635 394.627206,194.251704 394.699111,192.175634 C395.280582,175.387102 409.361751,162.248684 426.150283,162.830155 C428.130557,162.898742 430.099392,163.160669 432.028721,163.612202 Z",
    id: "path-26"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "2.9%",
    width: "109.8%",
    height: "99.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-27"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.423233696   0 0 0 0 0.423233696   0 0 0 0 0.423233696  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 109,
    height: 74,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50%",
    fx: "48.9155431%",
    fy: "50%",
    r: "49.173591%",
    gradientTransform: "translate(0.489155,0.500000),scale(0.140351,1.000000),rotate(90.000000),scale(1.000000,6.261852),translate(-0.489155,-0.500000)",
    id: "radialGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M721.63479,155.477763 C725.456298,162.020976 721.63479,172.842443 705.329689,179.133994 C703.036784,180.140642 703.036784,184.670558 696.158069,183.915572 C691.57226,183.412248 694.294944,172.757966 704.326124,151.952727 C713.317563,149.940609 719.087118,151.115621 721.63479,155.477763 Z M717.990627,158.138655 C715.875067,155.262982 709.151197,155.729425 707.622594,156.987735 C706.093991,158.246045 701.508181,173.597429 706.858292,173.597429 C713.227472,172.590781 720.106187,161.014327 717.990627,158.138655 Z",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.1%",
    y: "-10.6%",
    width: "124.1%",
    height: "121.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-31"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "75.4740169%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "40.463396%",
    y2: "21.5777229%",
    id: "linearGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-17.8%",
    y: "-14.3%",
    width: "135.6%",
    height: "128.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-35"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.5617232%",
    y1: "0%",
    x2: "62.1942748%",
    y2: "100%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-37",
    cx: 605,
    cy: 222.7894,
    rx: 1.74326923,
    ry: 1.7228145
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-57.4%",
    y: "-58.0%",
    width: "214.7%",
    height: "216.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-38"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.9973917%",
    y1: "100%",
    x2: "39.3363291%",
    y2: "0%",
    id: "linearGradient-39"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.078113,1.000000),rotate(90.000000),scale(1.000000,13.555189),translate(-0.489155,-0.509384)",
    id: "radialGradient-40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M607.6875,248 C608.489583,248 609.145833,248.65625 609.145833,249.458333 L609.145833,249.458333 L609.145833,251.395 C610.480208,251.739167 611.73875,252.264167 612.896667,252.948125 L612.896667,252.948125 L614.264583,251.57875 C614.831875,251.011458 615.760833,251.011458 616.328125,251.57875 L616.328125,251.57875 L619.42125,254.671875 C619.988542,255.239167 619.988542,256.168125 619.42125,256.735417 L619.42125,256.735417 L618.051875,258.103333 C618.735833,259.26125 619.260833,260.519792 619.605,261.854167 L619.605,261.854167 L621.541667,261.854167 C622.34375,261.854167 623,262.510417 623,263.3125 L623,263.3125 L623,267.6875 C623,268.489583 622.34375,269.145833 621.541667,269.145833 L621.541667,269.145833 L619.605,269.145833 C619.260833,270.480208 618.735833,271.73875 618.051875,272.896667 L618.051875,272.896667 L619.42125,274.264583 C619.988542,274.831875 619.988542,275.760833 619.42125,276.328125 L619.42125,276.328125 L616.328125,279.42125 C615.760833,279.988542 614.831875,279.988542 614.264583,279.42125 L614.264583,279.42125 L612.896667,278.051875 C611.73875,278.735833 610.480208,279.260833 609.145833,279.605 L609.145833,279.605 L609.145833,281.541667 C609.145833,282.34375 608.489583,283 607.6875,283 L607.6875,283 L603.3125,283 C602.510417,283 601.854167,282.34375 601.854167,281.541667 L601.854167,281.541667 L601.854167,279.605 C600.519792,279.260833 599.26125,278.735833 598.103333,278.051875 L598.103333,278.051875 L596.735417,279.42125 C596.168125,279.988542 595.239167,279.988542 594.671875,279.42125 L594.671875,279.42125 L591.57875,276.328125 C591.011458,275.760833 591.011458,274.831875 591.57875,274.264583 L591.57875,274.264583 L592.948125,272.896667 C592.264167,271.73875 591.739167,270.480208 591.395,269.145833 L591.395,269.145833 L589.458333,269.145833 C588.65625,269.145833 588,268.489583 588,267.6875 L588,267.6875 L588,263.3125 C588,262.510417 588.65625,261.854167 589.458333,261.854167 L589.458333,261.854167 L591.395,261.854167 C591.739167,260.519792 592.264167,259.26125 592.948125,258.103333 L592.948125,258.103333 L591.57875,256.735417 C591.011458,256.168125 591.011458,255.239167 591.57875,254.671875 L591.57875,254.671875 L594.671875,251.57875 C595.239167,251.011458 596.168125,251.011458 596.735417,251.57875 L596.735417,251.57875 L598.103333,252.948125 C599.26125,252.264167 600.519792,251.739167 601.854167,251.395 L601.854167,251.395 L601.854167,249.458333 C601.854167,248.65625 602.510417,248 603.3125,248 L603.3125,248 Z M605.5,259.666667 C602.278339,259.666667 599.666667,262.278339 599.666667,265.5 C599.666667,268.721661 602.278339,271.333333 605.5,271.333333 C608.721661,271.333333 611.333333,268.721661 611.333333,265.5 C611.333333,262.278339 608.721661,259.666667 605.5,259.666667 Z",
    id: "path-41"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.2%",
    y: "-10.0%",
    width: "120.4%",
    height: "131.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-42"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M523.306416,183.197974 L624.219982,204.177585 C637.035077,206.841803 646.575824,217.611022 647.675998,230.65381 C648.720396,243.035355 640.006111,254.114041 627.726951,256.015528 L525.893516,271.784926 C501.990108,275.486484 479.611861,259.109648 475.910303,235.20624 C475.479675,232.425388 475.318057,229.609505 475.42769,226.797645 L475.676114,220.426151 C476.528191,198.57228 494.935,181.546962 516.788871,182.39904 C518.979757,182.484462 521.159765,182.751692 523.306416,183.197974 Z",
    id: "path-43"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.5%",
    y: "3.0%",
    width: "105.2%",
    height: "96.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-44"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.8,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.423233696   0 0 0 0 0.423233696   0 0 0 0 0.423233696  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 176.174046,
    height: 106.245801,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-46",
    cx: 328,
    cy: 75,
    r: 9
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-33.3%",
    width: "233.3%",
    height: "222.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-47"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-48",
    cx: 704,
    cy: 257,
    r: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.0%",
    y: "-15.0%",
    width: "160.0%",
    height: "155.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-49"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-50",
    cx: 321,
    cy: 269,
    r: 14
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.4%",
    y: "-21.4%",
    width: "185.7%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-51"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-52",
    cx: 684,
    cy: 58,
    r: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.1%",
    y: "-23.1%",
    width: "192.3%",
    height: "184.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-53"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-54",
    cx: 209,
    cy: 131,
    r: 9
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-33.3%",
    width: "233.3%",
    height: "222.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-55"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(-151.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(144.182324, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849.722194,7.33221826 C854.941578,5.9396147 860.3601,9.05474421 861.75863,14.2520114 L861.75863,14.2520114 L865.126008,26.7927096 C874.183339,26.7030612 883.292293,27.874104 892.234595,30.3497566 L892.234595,30.3497566 L898.756567,19.1012368 C901.457685,14.4425878 907.495532,12.8316069 912.174005,15.5212791 L912.174005,15.5212791 L937.692957,30.1922042 C942.371421,32.881891 943.989258,38.8941538 941.28814,43.5528028 L941.28814,43.5528028 L934.766169,54.8013226 C941.390421,61.2749431 946.963367,68.544581 951.414064,76.4000467 L951.414064,76.4000467 L964.004531,73.0335761 C969.223915,71.6409725 974.642437,74.756102 976.040967,79.9533693 L976.040967,79.9533693 L983.666368,108.291168 C985.064898,113.488435 981.936512,118.883998 976.717129,120.276602 L976.717129,120.276602 L964.123066,123.629712 C964.213096,132.648664 963.03707,141.71902 960.550883,150.623432 L960.550883,150.623432 L971.847269,157.117768 C976.525742,159.80744 978.143578,165.819703 975.442475,170.47836 L975.442475,170.47836 L960.709091,195.889165 C958.007973,200.547814 951.970126,202.158795 947.291653,199.469122 L947.291653,199.469122 L935.995268,192.974787 C929.4941,199.570971 922.193527,205.120302 914.304634,209.55214 L914.304634,209.55214 L917.68543,222.089258 C919.08396,227.286525 915.955574,232.682088 910.736191,234.074691 L910.736191,234.074691 L882.277806,241.667782 C877.058422,243.060385 871.6399,239.945256 870.24137,234.747989 L870.24137,234.747989 L866.873992,222.20729 C857.816661,222.296939 848.707707,221.125896 839.765405,218.650243 L839.765405,218.650243 L833.243433,229.898763 C830.542315,234.557412 824.504468,236.168393 819.825995,233.478721 L819.825995,233.478721 L794.307043,218.807796 C789.628579,216.118109 788.010742,210.105846 790.71186,205.447197 L790.71186,205.447197 L797.233831,194.198677 C790.609579,187.725057 785.036633,180.455419 780.585936,172.599953 L780.585936,172.599953 L767.995469,175.966424 C762.776085,177.359027 757.357563,174.243898 755.959033,169.046631 L755.959033,169.046631 L748.333632,140.708832 C746.935102,135.511565 750.063488,130.116002 755.282871,128.723398 L755.282871,128.723398 L767.876934,125.370288 C767.786904,116.351336 768.96293,107.28098 771.449117,98.3765681 L771.449117,98.3765681 L760.152731,91.8822321 C755.474258,89.1925599 753.856422,83.180297 756.557525,78.5216397 L756.557525,78.5216397 L771.290909,53.1108352 C773.992027,48.4521862 780.029874,46.8412052 784.708347,49.5308775 L784.708347,49.5308775 L796.004732,56.0252134 C802.5059,49.4290295 809.806473,43.8796984 817.695366,39.4478602 L817.695366,39.4478602 L814.31457,26.910742 C812.91604,21.7134747 816.044426,16.3179122 821.263809,14.9253086 L821.263809,14.9253086 Z M831.974683,104.938713 C821.125388,123.650753 827.563876,147.577702 846.355474,158.381142 C865.147139,169.184465 889.175905,162.773259 900.025317,144.061287 C910.874612,125.349247 904.436124,101.422298 885.644526,90.6188576 C866.852861,79.8155347 842.824095,86.2267414 831.974683,104.938713 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.625,46.0577137 C649.820833,46.0577137 655.708333,51.9452137 655.708333,59.141047 L655.708333,59.141047 L655.708333,76.5157137 C667.679583,79.6033803 678.9705,84.3133803 689.358667,90.4494637 L689.358667,90.4494637 L701.630833,78.1642137 C706.72025,73.074797 715.054333,73.074797 720.14375,78.1642137 L720.14375,78.1642137 L747.8935,105.913964 C752.982917,111.00338 752.982917,119.337464 747.8935,124.42688 L747.8935,124.42688 L735.60825,136.699047 C741.744333,147.087214 746.454333,158.37813 749.542,170.34938 L749.542,170.34938 L766.916667,170.34938 C774.1125,170.34938 780,176.23688 780,183.432714 L780,183.432714 L780,222.682714 C780,229.878547 774.1125,235.766047 766.916667,235.766047 L766.916667,235.766047 L749.542,235.766047 C746.454333,247.737297 741.744333,259.028214 735.60825,269.41638 L735.60825,269.41638 L747.8935,281.688547 C752.982917,286.777964 752.982917,295.112047 747.8935,300.201464 L747.8935,300.201464 L720.14375,327.951214 C715.054333,333.04063 706.72025,333.04063 701.630833,327.951214 L701.630833,327.951214 L689.358667,315.665964 C678.9705,321.802047 667.679583,326.512047 655.708333,329.599714 L655.708333,329.599714 L655.708333,346.97438 C655.708333,354.170214 649.820833,360.057714 642.625,360.057714 L642.625,360.057714 L603.375,360.057714 C596.179167,360.057714 590.291667,354.170214 590.291667,346.97438 L590.291667,346.97438 L590.291667,329.599714 C578.320417,326.512047 567.0295,321.802047 556.641333,315.665964 L556.641333,315.665964 L544.369167,327.951214 C539.27975,333.04063 530.945667,333.04063 525.85625,327.951214 L525.85625,327.951214 L498.1065,300.201464 C493.017083,295.112047 493.017083,286.777964 498.1065,281.688547 L498.1065,281.688547 L510.39175,269.41638 C504.255667,259.028214 499.545667,247.737297 496.458,235.766047 L496.458,235.766047 L479.083333,235.766047 C471.8875,235.766047 466,229.878547 466,222.682714 L466,222.682714 L466,183.432714 C466,176.23688 471.8875,170.34938 479.083333,170.34938 L479.083333,170.34938 L496.458,170.34938 C499.545667,158.37813 504.255667,147.087214 510.39175,136.699047 L510.39175,136.699047 L498.1065,124.42688 C493.017083,119.337464 493.017083,111.00338 498.1065,105.913964 L498.1065,105.913964 L525.85625,78.1642137 C530.945667,73.074797 539.27975,73.074797 544.369167,78.1642137 L544.369167,78.1642137 L556.641333,90.4494637 C567.0295,84.3133803 578.320417,79.6033803 590.291667,76.5157137 L590.291667,76.5157137 L590.291667,59.141047 C590.291667,51.9452137 596.179167,46.0577137 603.375,46.0577137 L603.375,46.0577137 Z M622.5,150.057714 C593.505051,150.057714 570,173.562764 570,202.557714 C570,231.552663 593.505051,255.057714 622.5,255.057714 C651.494949,255.057714 675,231.552663 675,202.557714 C675,173.562764 651.494949,150.057714 622.5,150.057714 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.625,46.0577137 C387.820833,46.0577137 393.708333,51.9452137 393.708333,59.141047 L393.708333,59.141047 L393.708333,76.5157137 C405.679583,79.6033803 416.9705,84.3133803 427.358667,90.4494637 L427.358667,90.4494637 L439.630833,78.1642137 C444.72025,73.074797 453.054333,73.074797 458.14375,78.1642137 L458.14375,78.1642137 L485.8935,105.913964 C490.982917,111.00338 490.982917,119.337464 485.8935,124.42688 L485.8935,124.42688 L473.60825,136.699047 C479.744333,147.087214 484.454333,158.37813 487.542,170.34938 L487.542,170.34938 L504.916667,170.34938 C512.1125,170.34938 518,176.23688 518,183.432714 L518,183.432714 L518,222.682714 C518,229.878547 512.1125,235.766047 504.916667,235.766047 L504.916667,235.766047 L487.542,235.766047 C484.454333,247.737297 479.744333,259.028214 473.60825,269.41638 L473.60825,269.41638 L485.8935,281.688547 C490.982917,286.777964 490.982917,295.112047 485.8935,300.201464 L485.8935,300.201464 L458.14375,327.951214 C453.054333,333.04063 444.72025,333.04063 439.630833,327.951214 L439.630833,327.951214 L427.358667,315.665964 C416.9705,321.802047 405.679583,326.512047 393.708333,329.599714 L393.708333,329.599714 L393.708333,346.97438 C393.708333,354.170214 387.820833,360.057714 380.625,360.057714 L380.625,360.057714 L341.375,360.057714 C334.179167,360.057714 328.291667,354.170214 328.291667,346.97438 L328.291667,346.97438 L328.291667,329.599714 C316.320417,326.512047 305.0295,321.802047 294.641333,315.665964 L294.641333,315.665964 L282.369167,327.951214 C277.27975,333.04063 268.945667,333.04063 263.85625,327.951214 L263.85625,327.951214 L236.1065,300.201464 C231.017083,295.112047 231.017083,286.777964 236.1065,281.688547 L236.1065,281.688547 L248.39175,269.41638 C242.255667,259.028214 237.545667,247.737297 234.458,235.766047 L234.458,235.766047 L217.083333,235.766047 C209.8875,235.766047 204,229.878547 204,222.682714 L204,222.682714 L204,183.432714 C204,176.23688 209.8875,170.34938 217.083333,170.34938 L217.083333,170.34938 L234.458,170.34938 C237.545667,158.37813 242.255667,147.087214 248.39175,136.699047 L248.39175,136.699047 L236.1065,124.42688 C231.017083,119.337464 231.017083,111.00338 236.1065,105.913964 L236.1065,105.913964 L263.85625,78.1642137 C268.945667,73.074797 277.27975,73.074797 282.369167,78.1642137 L282.369167,78.1642137 L294.641333,90.4494637 C305.0295,84.3133803 316.320417,79.6033803 328.291667,76.5157137 L328.291667,76.5157137 L328.291667,59.141047 C328.291667,51.9452137 334.179167,46.0577137 341.375,46.0577137 L341.375,46.0577137 Z M360.5,150.057714 C331.505051,150.057714 308,173.562764 308,202.557714 C308,231.552663 331.505051,255.057714 360.5,255.057714 C389.494949,255.057714 413,231.552663 413,202.557714 C413,173.562764 389.494949,150.057714 360.5,150.057714 Z",
    id: "Combined-Shape-Copy-3",
    fill: "url(#linearGradient-2)",
    opacity: 0.5,
    transform: "translate(361.000000, 203.000000) scale(-1, 1) translate(-361.000000, -203.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.722194,7.33221826 C106.941578,5.9396147 112.3601,9.05474421 113.75863,14.2520114 L113.75863,14.2520114 L117.126008,26.7927096 C126.183339,26.7030612 135.292293,27.874104 144.234595,30.3497566 L144.234595,30.3497566 L150.756567,19.1012368 C153.457685,14.4425878 159.495532,12.8316069 164.174005,15.5212791 L164.174005,15.5212791 L189.692957,30.1922042 C194.371421,32.881891 195.989258,38.8941538 193.28814,43.5528028 L193.28814,43.5528028 L186.766169,54.8013226 C193.390421,61.2749431 198.963367,68.544581 203.414064,76.4000467 L203.414064,76.4000467 L216.004531,73.0335761 C221.223915,71.6409725 226.642437,74.756102 228.040967,79.9533693 L228.040967,79.9533693 L235.666368,108.291168 C237.064898,113.488435 233.936512,118.883998 228.717129,120.276602 L228.717129,120.276602 L216.123066,123.629712 C216.213096,132.648664 215.03707,141.71902 212.550883,150.623432 L212.550883,150.623432 L223.847269,157.117768 C228.525742,159.80744 230.143578,165.819703 227.442475,170.47836 L227.442475,170.47836 L212.709091,195.889165 C210.007973,200.547814 203.970126,202.158795 199.291653,199.469122 L199.291653,199.469122 L187.995268,192.974787 C181.4941,199.570971 174.193527,205.120302 166.304634,209.55214 L166.304634,209.55214 L169.68543,222.089258 C171.08396,227.286525 167.955574,232.682088 162.736191,234.074691 L162.736191,234.074691 L134.277806,241.667782 C129.058422,243.060385 123.6399,239.945256 122.24137,234.747989 L122.24137,234.747989 L118.873992,222.20729 C109.816661,222.296939 100.707707,221.125896 91.7654045,218.650243 L91.7654045,218.650243 L85.2434331,229.898763 C82.5423154,234.557412 76.5044685,236.168393 71.8259954,233.478721 L71.8259954,233.478721 L46.3070432,218.807796 C41.6285785,216.118109 40.0107423,210.105846 42.71186,205.447197 L42.71186,205.447197 L49.2338314,194.198677 C42.6095785,187.725057 37.0366333,180.455419 32.5859362,172.599953 L32.5859362,172.599953 L19.9954685,175.966424 C14.7760853,177.359027 9.35756284,174.243898 7.95903331,169.046631 L7.95903331,169.046631 L0.333631953,140.708832 C-1.06489757,135.511565 2.0634878,130.116002 7.28287106,128.723398 L7.28287106,128.723398 L19.8769339,125.370288 C19.786904,116.351336 20.96293,107.28098 23.4491173,98.3765681 L23.4491173,98.3765681 L12.1527315,91.8822321 C7.47425841,89.1925599 5.8564222,83.180297 8.55752542,78.5216397 L8.55752542,78.5216397 L23.290909,53.1108352 C25.9920267,48.4521862 32.0298736,46.8412052 36.7083467,49.5308775 L36.7083467,49.5308775 L48.0047325,56.0252134 C54.5059003,49.4290295 61.8064728,43.8796984 69.695366,39.4478602 L69.695366,39.4478602 L66.31457,26.910742 C64.9160405,21.7134747 68.0444259,16.3179122 73.2638091,14.9253086 L73.2638091,14.9253086 Z M83.9746829,104.938713 C73.125388,123.650753 79.5638764,147.577702 98.3554739,158.381142 C117.147139,169.184465 141.175905,162.773259 152.025317,144.061287 C162.874612,125.349247 156.436124,101.422298 137.644526,90.6188576 C118.852861,79.8155347 94.8240949,86.2267414 83.9746829,104.938713 Z",
    id: "Combined-Shape-Copy-4",
    fill: "url(#linearGradient-1)",
    opacity: 0.5,
    transform: "translate(118.000000, 124.500000) scale(-1, 1) translate(-118.000000, -124.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(721.500000, 26.500000) scale(-1, 1) translate(-721.500000, -26.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy",
    transform: "translate(248.500000, 13.500000) scale(-1, -1) rotate(-180.000000) translate(-248.500000, -13.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-2",
    transform: "translate(304.000000, 7.000000) scale(-1, 1) rotate(-360.000000) translate(-304.000000, -7.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-5",
    transform: "translate(531.000000, 27.000000) scale(-1, 1) rotate(-360.000000) translate(-531.000000, -27.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    transform: "translate(317.692236, 141.718633) rotate(-45.000000) translate(-317.692236, -141.718633) ",
    x: 315.319101,
    y: 138.557342,
    width: 4.74626866,
    height: 6.32258065
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.932835,129.412435 L313.410447,129.412435 C320.590149,129.412435 326.410447,135.232734 326.410447,142.412435 L326.410447,142.847919 L326.410447,142.847919 L297.932835,142.847919 L297.932835,142.412435 C297.932835,135.232734 303.753133,129.412435 310.932835,129.412435 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-13)",
    transform: "translate(312.171641, 136.130177) scale(-1, 1) rotate(45.000000) translate(-312.171641, -136.130177) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    transform: "translate(382.051788, 141.718633) scale(-1, 1) rotate(-45.000000) translate(-382.051788, -141.718633) ",
    x: 379.678653,
    y: 138.557342,
    width: 4.74626866,
    height: 6.32258065
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.333576,129.412435 L388.811188,129.412435 C395.99089,129.412435 401.811188,135.232734 401.811188,142.412435 L401.811188,142.847919 L401.811188,142.847919 L373.333576,142.847919 L373.333576,142.412435 C373.333576,135.232734 379.153875,129.412435 386.333576,129.412435 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-13)",
    transform: "translate(387.572382, 136.130177) rotate(45.000000) translate(-387.572382, -136.130177) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-14)",
    cx: 350,
    cy: 212.982364,
    rx: 49,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-15)",
    opacity: 0.5,
    cx: 327,
    cy: 214.482364,
    rx: 27,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.108749,205.046519 L329.434218,205.04363 L329.430607,212.950467 C329.429809,214.697664 328.013625,216.113848 326.266428,216.114646 C324.521293,216.115443 323.105935,214.701377 323.105138,212.956242 C323.105137,212.95528 323.105137,212.954318 323.105138,212.953356 L323.108749,205.046519 L323.108749,205.046519 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-16)",
    transform: "translate(326.269678, 210.579138) rotate(-315.000000) translate(-326.269678, -210.579138) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.569393,205.046519 L376.894863,205.04363 L376.891252,212.950467 C376.890454,214.697664 375.47427,216.113848 373.727072,216.114646 C371.981937,216.115443 370.566579,214.701377 370.565782,212.956242 C370.565782,212.95528 370.565782,212.954318 370.565782,212.953356 L370.569393,205.046519 L370.569393,205.046519 Z",
    id: "Rectangle",
    fill: "#D9D9D9",
    transform: "translate(373.730322, 210.579138) scale(-1, 1) rotate(-315.000000) translate(-373.730322, -210.579138) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D9D9D9",
    cx: 350.5,
    cy: 169.982364,
    r: 42.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-18)",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-45",
    stroke: "#FF520B",
    strokeWidth: 4,
    strokeLinecap: "round",
    points: "335.332012 183.482364 350 170.099385 334 146.482364"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#575756",
    cx: 350.5,
    cy: 169.982364,
    r: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-19)",
    opacity: 0.5,
    cx: 506,
    cy: 284.726315,
    rx: 115,
    ry: 9.24395112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.254,111 L613.746,111 C617.752274,111 621,114.247726 621,118.254 L621,257.924479 C621,260.595328 618.834849,262.760479 616.164,262.760479 L395.836,262.760479 C393.165151,262.760479 391,260.595328 391,257.924479 L391,118.254 C391,114.247726 394.247726,111 398.254,111 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(467.942059, 166.635724) rotate(17.000000) translate(-467.942059, -166.635724) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-23)",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-21)",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-6",
    transform: "translate(437.437854, 211.685624) rotate(17.000000) translate(-437.437854, -211.685624) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-25)",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-21)",
    fillRule: "evenodd",
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(447.917615, 192.175634) rotate(-58.000000) translate(-447.917615, -192.175634) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-27)",
    xlinkHref: "#path-26"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#D9D9D9",
    mask: "url(#mask-28)",
    strokeWidth: 8.4,
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M532.625,165 C534.320833,165 535.708333,166.3875 535.708333,168.083333 L535.708333,168.083333 L535.708333,172.178 C538.529583,172.905667 541.1905,174.015667 543.638667,175.46175 L543.638667,175.46175 L546.530833,172.5665 C547.73025,171.367083 549.694333,171.367083 550.89375,172.5665 L550.89375,172.5665 L557.4335,179.10625 C558.632917,180.305667 558.632917,182.26975 557.4335,183.469167 L557.4335,183.469167 L554.53825,186.361333 C555.984333,188.8095 557.094333,191.470417 557.822,194.291667 L557.822,194.291667 L561.916667,194.291667 C563.6125,194.291667 565,195.679167 565,197.375 L565,197.375 L565,206.625 C565,208.320833 563.6125,209.708333 561.916667,209.708333 L561.916667,209.708333 L557.822,209.708333 C557.094333,212.529583 555.984333,215.1905 554.53825,217.638667 L554.53825,217.638667 L557.4335,220.530833 C558.632917,221.73025 558.632917,223.694333 557.4335,224.89375 L557.4335,224.89375 L550.89375,231.4335 C549.694333,232.632917 547.73025,232.632917 546.530833,231.4335 L546.530833,231.4335 L543.638667,228.53825 C541.1905,229.984333 538.529583,231.094333 535.708333,231.822 L535.708333,231.822 L535.708333,235.916667 C535.708333,237.6125 534.320833,239 532.625,239 L532.625,239 L523.375,239 C521.679167,239 520.291667,237.6125 520.291667,235.916667 L520.291667,235.916667 L520.291667,231.822 C517.470417,231.094333 514.8095,229.984333 512.361333,228.53825 L512.361333,228.53825 L509.469167,231.4335 C508.26975,232.632917 506.305667,232.632917 505.10625,231.4335 L505.10625,231.4335 L498.5665,224.89375 C497.367083,223.694333 497.367083,221.73025 498.5665,220.530833 L498.5665,220.530833 L501.46175,217.638667 C500.015667,215.1905 498.905667,212.529583 498.178,209.708333 L498.178,209.708333 L494.083333,209.708333 C492.3875,209.708333 491,208.320833 491,206.625 L491,206.625 L491,197.375 C491,195.679167 492.3875,194.291667 494.083333,194.291667 L494.083333,194.291667 L498.178,194.291667 C498.905667,191.470417 500.015667,188.8095 501.46175,186.361333 L501.46175,186.361333 L498.5665,183.469167 C497.367083,182.26975 497.367083,180.305667 498.5665,179.10625 L498.5665,179.10625 L505.10625,172.5665 C506.305667,171.367083 508.26975,171.367083 509.469167,172.5665 L509.469167,172.5665 L512.361333,175.46175 C514.8095,174.015667 517.470417,172.905667 520.291667,172.178 L520.291667,172.178 L520.291667,168.083333 C520.291667,166.3875 521.679167,165 523.375,165 L523.375,165 Z M527.5,189 C520.596441,189 515,194.596441 515,201.5 C515,208.403559 520.596441,214 527.5,214 C534.403559,214 540,208.403559 540,201.5 C540,194.596441 534.403559,189 527.5,189 Z",
    id: "Combined-Shape-Copy-7",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.836,110.482364 L616.164,110.482364 C618.834849,110.482364 621,112.647515 621,115.318364 L621,132.254819 L621,132.254819 L391,132.254819 L391,115.318364 C391,112.647515 393.165151,110.482364 395.836,110.482364 Z",
    id: "Rectangle",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    x: 481.789474,
    y: 116.530268,
    width: 133.157895,
    height: 9.67664671,
    rx: 4.836
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 423.196507,
    cy: 121.368592,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2CB5D6",
    cx: 412.772862,
    cy: 121.368592,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF520B",
    cx: 402.349217,
    cy: 121.683279,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.530169,167.151241 C684.759252,165.759084 683.130199,164.104164 681.031057,163.617627 C678.931915,163.13109 678.33642,164.078807 676.517164,163.657142 C677.767382,164.882259 684.246786,168.705924 685.530169,167.151241 Z",
    id: "Path-26",
    fill: "#D9D9D9",
    transform: "translate(681.023666, 165.496105) rotate(39.000000) translate(-681.023666, -165.496105) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.743332,166.968144 C684.233762,166.503028 683.505804,164.95264 684.233762,163.402253 C684.719067,162.368661 685.641146,161.335069 687,160.301478 C686.805878,161.386749 686.708817,162.213622 686.708817,162.782098 C686.708817,163.634811 686.344838,166.580547 684.743332,166.968144 Z",
    id: "Path-27",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-29)",
    cx: 670.5,
    cy: 195,
    rx: 28.5,
    ry: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-30"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-31)",
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M644.761319,141.36855 C651.570484,139.789517 660.316711,139 671,139 C681.683288,139 690.429515,139.789516 697.23868,141.368549 L697.238681,141.368548 C701.839968,142.435578 705.067185,146.576617 704.977858,151.299161 C704.414185,181.09972 693.088232,196 671,196 C648.911767,196 637.585814,181.099719 637.022142,151.299158 L637.022145,151.299157 C636.932819,146.576616 640.160034,142.435579 644.761319,141.36855 Z",
    id: "Path-23",
    fill: "url(#linearGradient-32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 670.5,
    cy: 145,
    rx: 30.5,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-33)",
    opacity: 0.200000003,
    transform: "translate(670.000000, 144.500000) rotate(-90.000000) translate(-670.000000, -144.500000) ",
    cx: 670,
    cy: 144.5,
    rx: 4,
    ry: 30.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.868531,154 L688.851803,157.278958 C689.06737,157.4208 689.219761,157.640482 689.277116,157.892074 L692.898506,173.777736 C693.021258,174.316206 692.684253,174.852234 692.145783,174.974987 C692.072863,174.99161 691.998309,175 691.923519,175 L680.676816,175 C680.210164,175 679.805549,174.677243 679.701829,174.222264 L676.073454,158.30596 C675.966824,157.838214 676.207394,157.36065 676.646729,157.16793 L683.868531,154 Z M683.868531,157.818182 C683.134102,157.818182 682.538729,158.530456 682.538729,159.409091 C682.538729,160.287726 683.134102,161 683.868531,161 C684.60296,161 685.198332,160.287726 685.198332,159.409091 C685.198332,158.530456 684.60296,157.818182 683.868531,157.818182 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-34)",
    filter: "url(#filter-35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.496121,154 L687.668338,156.850158 C687.87943,157.039819 688,157.310236 688,157.594016 L688,170 C688,170.552285 687.552285,171 687,171 L677,171 C676.447715,171 676,170.552285 676,170 L676,157.591438 C676,157.309157 676.119304,157.040025 676.328466,156.850464 L679.473684,154 L684.496121,154 Z M682,155.888889 C681.337258,155.888889 680.8,156.452678 680.8,157.148148 C680.8,157.843618 681.337258,158.407407 682,158.407407 C682.662742,158.407407 683.2,157.843618 683.2,157.148148 C683.2,156.452678 682.662742,155.888889 682,155.888889 Z",
    id: "Combined-Shape",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679,147.764706 L679,147.5 C679,146.671573 679.671573,146 680.5,146 C681.328427,146 682,146.671573 682,147.5 L682,156 L682,156",
    id: "Path-25",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 604.246154,
    cy: 265.213707,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 604.246154,
    cy: 265.213707,
    r: 54
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.2,
    fill: "#62EBB9",
    cx: 604.246154,
    cy: 265.213707,
    rx: 42.2153846,
    ry: 42.2089552
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.25,
    fill: "#62EBB9",
    cx: 604.246154,
    cy: 265.213707,
    rx: 36.1846154,
    ry: 36.1791045
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.964835,219.232364 C580.591953,219.232364 577.857692,221.966625 577.857692,225.339507 L577.857692,303.580445 C577.857692,306.953327 580.591953,309.687588 583.964835,309.687588 L626.035165,309.687588 C629.408047,309.687588 632.142308,306.953327 632.142308,303.580445 L632.142308,225.339507 C632.142308,221.966625 629.408047,219.232364 626.035165,219.232364 L583.964835,219.232364 Z",
    id: "Rectangle",
    stroke: "url(#linearGradient-36)",
    strokeWidth: 1.5,
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.65,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-38)",
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M584.022802,221.927993 L592.041622,221.927993 C593.751208,221.927993 595.349039,222.777523 596.305099,224.194786 L596.733363,224.829644 C597.689422,226.246906 599.287253,227.096437 600.996839,227.096437 L609.003161,227.096437 C610.712747,227.096437 612.310578,226.246906 613.266637,224.829644 L613.694901,224.194786 C614.650961,222.777523 616.248792,221.927993 617.958378,221.927993 L625.977198,221.927993 C627.870746,221.927993 629.405769,223.463017 629.405769,225.356565 L629.405769,303.563388 C629.405769,305.456935 627.870746,306.991959 625.977198,306.991959 L584.022802,306.991959 C582.129254,306.991959 580.594231,305.456935 580.594231,303.563388 L580.594231,225.356565 C580.594231,223.463017 582.129254,221.927993 584.022802,221.927993 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-39)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-40)",
    cx: 604.246154,
    cy: 320.713707,
    rx: 48.2461538,
    ry: 3.76865672
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-42)",
    xlinkHref: "#path-41"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-21)",
    fillRule: "evenodd",
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M677.729379,118.211877 C677.729379,79.5519441 646.165454,48.2118766 607.229379,48.2118766 C568.293304,48.2118766 536.729379,79.5519441 536.729379,118.211877",
    id: "Oval",
    stroke: "#575756",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(607.229379, 83.211877) rotate(-49.000000) translate(-607.229379, -83.211877) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.215351,214.630428 C393.386721,27.6395397 295.43884,210.87057 211.741289,163.57316",
    id: "Oval-Copy-11",
    stroke: "#575756",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(318.478320, 171.605100) rotate(-544.000000) translate(-318.478320, -171.605100) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#00F0B5",
    transform: "translate(402.186540, 243.270477) rotate(-184.000000) translate(-402.186540, -243.270477) ",
    cx: 402.18654,
    cy: 243.270477,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#00F0B5",
    transform: "translate(429.000000, 154.000000) rotate(-184.000000) translate(-429.000000, -154.000000) ",
    cx: 429,
    cy: 154,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#00F5B1",
    transform: "translate(621.000000, 299.000000) rotate(-184.000000) translate(-621.000000, -299.000000) ",
    cx: 621,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 699.275159,
    y1: 264.202383,
    x2: 618.814417,
    y2: 296.668812,
    id: "Path-4",
    stroke: "#00F0B5",
    strokeWidth: 2,
    transform: "translate(659.271269, 280.475747) rotate(-184.000000) translate(-659.271269, -280.475747) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#575756",
    transform: "translate(591.000000, 163.000000) rotate(-49.000000) translate(-591.000000, -163.000000) ",
    cx: 591,
    cy: 163,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#575756",
    transform: "translate(423.000000, 171.000000) rotate(-49.000000) translate(-423.000000, -171.000000) ",
    cx: 423,
    cy: 171,
    r: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(561.443463, 226.797645) rotate(38.000000) translate(-561.443463, -226.797645) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-44)",
    xlinkHref: "#path-43"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#D9D9D9",
    mask: "url(#mask-45)",
    strokeWidth: 9.6,
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-47)",
    xlinkHref: "#path-46"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-49)",
    xlinkHref: "#path-48"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M700.285714,266 L692.309286,258.580614 C691.636686,257.954986 691.598607,256.902564 692.224236,256.229964 C692.251551,256.200597 692.27992,256.172229 692.309286,256.144914 C693.04748,255.458272 694.190401,255.457477 694.92955,256.143091 L700.285714,261.111324 L700.285714,261.111324 L713.067827,249.221864 C713.807477,248.533869 714.953495,248.535889 715.690714,249.226488 C716.365696,249.858784 716.400299,250.918541 715.768003,251.593523 C715.741742,251.621556 715.714525,251.648678 715.686399,251.674839 L700.285714,266 L700.285714,266 Z",
    id: "Path-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-51)",
    xlinkHref: "#path-50"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-53)",
    xlinkHref: "#path-52"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-55)",
    xlinkHref: "#path-54"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#FFFFFF",
    cx: 684,
    cy: 58,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    fill: "#FFFFFF",
    cx: 209,
    cy: 131,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.5,
    y1: 269.5,
    x2: 402.18654,
    y2: 243.270477,
    id: "Path-2",
    stroke: "#62EBB9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5,
    y1: 78.5,
    x2: 429,
    y2: 154,
    id: "Path-3",
    stroke: "#62EBB9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.428571,275 L312.906429,270.053743 C312.458028,269.652105 312.42012,268.963013 312.821758,268.514613 C312.848409,268.484859 312.876675,268.456593 312.906429,268.429942 C313.422545,267.96765 314.203654,267.967109 314.72041,268.428685 L318.428571,271.740883 L318.428571,271.740883 L327.277847,263.814468 C327.794944,263.351298 328.578105,263.352674 329.093571,263.817658 C329.543559,264.223577 329.579284,264.917426 329.173366,265.367414 C329.147292,265.396318 329.119699,265.423814 329.090704,265.449785 L318.428571,275 L318.428571,275 Z",
    id: "Path-Copy-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.285714,79 L322.604286,75.7024952 C322.305352,75.4347366 322.28008,74.9753419 322.547839,74.6764085 C322.565606,74.6565728 322.58445,74.6377287 322.604286,74.6199616 C322.948363,74.3117669 323.469103,74.311406 323.813607,74.6191235 L326.285714,76.8272553 L326.285714,76.8272553 L332.185231,71.542979 C332.529963,71.2341984 333.05207,71.2351157 333.395714,71.5451056 C333.695706,71.8157179 333.719523,72.278284 333.44891,72.5782757 C333.431528,72.597545 333.413133,72.6158758 333.393803,72.6331901 L326.285714,79 L326.285714,79 Z",
    id: "Path-Copy-4",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404IllustrationLg);
export default __webpack_public_path__ + "static/media/404-illustration-lg.f0d641426ccf6770b0318e4c84f42232.svg";
export { ForwardRef as ReactComponent };